const Configs = {
    NAMESPACE: "pixienes.heptadecane.xyz",
    COUNT_API_KEY: "3dc3e493-694b-469f-8404-f2fed96094b7"
}

export default Configs